import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaTwitterSquare,
  FaYoutube,
  FaWhatsapp,
  FaLinkedin,
} from "react-icons/fa";
import { FaLocationDot, FaXTwitter } from "react-icons/fa6";
import ChatBot from "../Hero/ChatBoat";
import ThemeToggle from "../ThemeToggle";
import { useSelector } from "react-redux"; // Access Redux state

const Footer = () => {
  const theme = useSelector((state) => state.theme.theme); // Get the theme from Redux store

  return (
    <>
      <div
        className={`relative overflow-hidden border-t ${
          theme === "dark" ? "bg-black text-white" : "bg-gray-100 text-gray-800"
        }`}
      >
        {/* Background Gradient */}
        <div
          className={`py-12 ${
            theme === "dark" ? "bg-black via-blue-900 to-black" : "bg-white"
          }`}
        >
          <div className="container mx-auto px-6 relative">
            <div className="grid md:grid-cols-3 gap-12">
              {/* Thank You Section */}
              <div>
                <ThemeToggle />
                <h1
                  className={`text-3xl font-bold mb-6 ${
                    theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                  }`}
                >
                  Thank You for Visiting Tripdekhoo!
                </h1>
                <p
                  className={`text-md leading-relaxed ${
                    theme === "dark" ? "text-gray-300" : "text-gray-600"
                  }`}
                >
                  Thanks for visiting! Whether you're dreaming of a tropical
                  escape, an exciting adventure, or a relaxing getaway,
                  Tripdekhoo is here to make it happen. We offer carefully
                  crafted holiday packages for all types of travelers and
                  budgets.
                </p>
              </div>

              {/* Why Choose Section */}
              {/* <div>
                <h2
                  className={`text-2xl font-bold mb-6 ${
                    theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                  }`}
                >
                  Why Choose Tripdekhoo?
                </h2>
                <ul className="text-md space-y-4">
                  <li>
                    <strong
                      className={`${
                        theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                      }`}
                    >
                      Expert Planning:
                    </strong>{" "}
                    10+ years of experience in the travel industry.
                  </li>
                  <li>
                    <strong
                      className={`${
                        theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                      }`}
                    >
                      Custom Packages:
                    </strong>{" "}
                    Tailored experiences to suit your preferences.
                  </li>
                  <li>
                    <strong
                      className={`${
                        theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                      }`}
                    >
                      Affordable Deals:
                    </strong>{" "}
                    Quality travel at the best prices.
                  </li>
                  <li>
                    <strong
                      className={`${
                        theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                      }`}
                    >
                      Personalized Service:
                    </strong>{" "}
                    Every detail of your trip, perfected.
                  </li>
                </ul>
                <p
                  className={`text-sm mt-6 font-bold ${
                    theme === "dark" ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  <span
                    className={`${
                      theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                    }`}
                  >
                    Office Hours:
                  </span>{" "}
                  24x7 Available
                </p>
              </div> */}
              <div>
                <h2
                  className={`text-2xl font-bold mb-6 ${
                    theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                  }`}
                >
                  Why Choose Tripdekhoo?
                </h2>
                <ul className="text-md space-y-4">
                  <li>
                    <strong
                      className={`${
                        theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                      }`}
                    >
                      Expert Planning:
                    </strong>{" "}
                    Over 10 years of experience in the travel industry.
                  </li>
                  <li>
                    <strong
                      className={`${
                        theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                      }`}
                    >
                      Custom Packages:
                    </strong>{" "}
                    Personalized experiences designed for you.
                  </li>
                  <li>
                    <strong
                      className={`${
                        theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                      }`}
                    >
                      Affordable Deals:
                    </strong>{" "}
                    High-quality travel at the best prices.
                  </li>
                  <li>
                    <strong
                      className={`${
                        theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                      }`}
                    >
                      Personalized Service:
                    </strong>{" "}
                    Every detail of your trip, expertly handled.
                  </li>
                  <li>
                    <strong
                      className={`${
                        theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                      }`}
                    >
                      24/7 Availability:
                    </strong>{" "}
                    We're here to assist you anytime.
                  </li>
                </ul>
                <p
                  className={`text-sm mt-6 font-bold ${
                    theme === "dark" ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  <span
                    className={`${
                      theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                    }`}
                  >
                    Office Hours:
                  </span>{" "}
                  24/7 Available
                </p>
              </div>

              {/* Contact & Stay Connected Section */}
              <div>
                <h2
                  className={`text-2xl font-bold mb-6 ${
                    theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                  }`}
                >
                  Contact
                </h2>
                <p
                  className={`text-md mb-2 ${
                    theme === "dark" ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  <strong>Mobile:</strong>+91 7742386069
                </p>
                <p
                  className={`text-md mb-2 ${
                    theme === "dark" ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  <strong>Email:</strong> support@tripdekhoo.com
                </p>
                <p
                  className={`text-md mt-6 ${
                    theme === "dark" ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  <strong>Address:</strong> RTech Capital Highstreet Plot No.
                  CP1-231, Apparel Park, Main Mahal Road, Jagatpura,
                  <br />
                  Jaipur, Rajasthan 302017 Rajasthan 302033
                </p>

                <h2
                  className={`text-xl font-bold mt-8 mb-6 ${
                    theme === "dark" ? "text-[#5b53fb]" : "text-[#5b53fb]"
                  }`}
                >
                  Stay Connected
                </h2>
                <p
                  className={`text-md mb-6 ${
                    theme === "dark" ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Follow us on social media for updates, tips, and exclusive
                  travel deals:
                </p>
                <div className="flex items-center gap-5">
                  <a
                    href="https://www.instagram.com/tripdekhoo.com_"
                    className={`text-3xl ${
                      theme === "dark"
                        ? "text-[#5b53fb] hover:text-[#4b45f4]"
                        : "text-[#5b53fb] hover:text-[#4b45f4]"
                    } transition`}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow us on Instagram"
                  >
                    <FaInstagram />
                  </a>
                  <a
                    href="https://www.facebook.com/tripdekhoo"
                    className={`text-3xl ${
                      theme === "dark"
                        ? "text-[#5b53fb] hover:text-[#4b45f4]"
                        : "text-[#5b53fb] hover:text-[#4b45f4]"
                    } transition`}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow us on Facebook"
                  >
                    <FaFacebook />
                  </a>
                  <a
                    href="https://x.com/tripdekhoo"
                    className={`text-3xl ${
                      theme === "dark"
                        ? "text-[#5b53fb] hover:text-[#4b45f4]"
                        : "text-[#5b53fb] hover:text-[#4b45f4]"
                    } transition`}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow us on X"
                  >
                    <FaXTwitter />
                  </a>
                  <a
                    href="https://www.youtube.com/@tripdekhoo"
                    className={`text-3xl ${
                      theme === "dark"
                        ? "text-[#5b53fb] hover:text-[#4b45f4]"
                        : "text-[#5b53fb] hover:text-[#4b45f4]"
                    } transition`}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow us on Youtube"
                  >
                    <FaYoutube />
                  </a>
                  <a
                    href="https://wa.me/917742386069"
                    className={`text-3xl ${
                      theme === "dark"
                        ? "text-[#5b53fb] hover:text-[#4b45f4]"
                        : "text-[#5b53fb] hover:text-[#4b45f4]"
                    } transition`}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Chat on Whatsapp"
                  >
                    <FaWhatsapp />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/tripdekhoo-com/"
                    className={`text-3xl ${
                      theme === "dark"
                        ? "text-[#5b53fb] hover:text-[#4b45f4]"
                        : "text-[#5b53fb] hover:text-[#4b45f4]"
                    } transition`}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow us on Linkdin"
                  >
                    <FaLinkedin />
                  </a>
                  <a
                    href="https://maps.app.goo.gl/F5rvCAM5a6u9Lgu37"
                    className={`text-3xl ${
                      theme === "dark"
                        ? "text-[#5b53fb] hover:text-[#4b45f4]"
                        : "text-[#5b53fb] hover:text-[#4b45f4]"
                    } transition`}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Location"
                  >
                    <FaLocationDot />
                  </a>
                </div>
              </div>
            </div>
            <ChatBot />
          </div>
        </div>

        {/* Footer Bottom */}
        <div
          className={`text-center border-t-2 py-6 ${
            theme === "dark"
              ? "bg-black border-[#5b53fb] text-gray-400"
              : "bg-gray-100 border-[#5b53fb] text-gray-700"
          }`}
        >
          <p>© 2025 Tripdekhoo. All Rights Reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
